import React, { useRef } from 'react';
import Accordion from '@mui/material/Accordion';
import axios from '../../axios';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddPackageModel from '../../components/AddPackageModel';
import { useLocation } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useReactToPrint } from 'react-to-print';
import { Card, CardContent, Box, Button, Chip } from '@mui/material';
import {
    Person,
    Phone,
    LocationOn,
    Agriculture,
    CalendarToday,
    Print,
    Inventory
} from '@mui/icons-material';
export default function ControlledAccordions() {
    const [expanded, setExpanded] = React.useState(false);
    const [products, setProducts] = React.useState([]);
    const compRef = useRef();
    const [prodError, setProdError] = React.useState('');

    const location = useLocation();
    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };
    React.useEffect(() => {
        getProducts();
    }, []);

    const getProducts = () => {
        axios
            .get(`/products`)
            .then((response) => {
                //back process
                setProducts(response.data.data);
            })
            .catch((error) => {
                setProdError('something went wrong');
            });
    };
    const PrintComponent = useReactToPrint({
        content: () => compRef.current
    });

    return (
        <Box
            sx={{
                backgroundColor: '#ffffff',
                minHeight: '100vh',
                padding: '0'
            }}
        >
            {/* Header Section */}
            <Box
                sx={{
                    backgroundColor: '#F9FAFB',
                    borderRadius: '12px',
                    padding: '20px 24px',
                    marginBottom: '20px',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.07)',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: '15px'
                }}
            >
                <Box>
                    <Typography
                        variant='h4'
                        sx={{
                            fontWeight: 700,
                            color: '#1f2937',
                            marginBottom: '4px'
                        }}
                    >
                        {location.state.name}
                    </Typography>
                    <Typography variant='body2' sx={{ color: '#6b7280' }}>
                        Farmer Details & Package Management
                    </Typography>
                </Box>
                <AddPackageModel
                    products={products}
                    prodError={prodError}
                    farmerId={location.state._id}
                />
            </Box>

            {/* Farmer Information Card */}
            <Card
                sx={{
                    borderRadius: '16px',
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                    border: '1px solid #e5e7eb',
                    marginBottom: '24px'
                }}
            >
                <CardContent sx={{ padding: '32px' }}>
                    <Typography
                        variant='h6'
                        sx={{
                            color: '#1f2937',
                            fontWeight: 600,
                            marginBottom: '24px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px'
                        }}
                    >
                        <Person sx={{ color: '#085d40' }} />
                        Farmer Information
                    </Typography>

                    <Box
                        sx={{
                            display: 'grid',
                            gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
                            gap: '24px'
                        }}
                    >
                        {/* Name */}
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px',
                                padding: '16px',
                                backgroundColor: '#f8fafc',
                                borderRadius: '12px',
                                border: '1px solid #e2e8f0'
                            }}
                        >
                            <Person sx={{ color: '#4b5563', fontSize: '20px' }} />
                            <Box>
                                <Typography
                                    variant='caption'
                                    sx={{
                                        color: '#6b7280',
                                        fontWeight: 600,
                                        textTransform: 'uppercase',
                                        fontSize: '11px'
                                    }}
                                >
                                    Name
                                </Typography>
                                <Typography
                                    variant='body1'
                                    sx={{
                                        color: '#1f2937',
                                        fontWeight: 600,
                                        fontSize: '16px'
                                    }}
                                >
                                    {location.state.name}
                                </Typography>
                            </Box>
                        </Box>

                        {/* Contact */}
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px',
                                padding: '16px',
                                backgroundColor: '#f8fafc',
                                borderRadius: '12px',
                                border: '1px solid #e2e8f0'
                            }}
                        >
                            <Phone sx={{ color: '#4b5563', fontSize: '20px' }} />
                            <Box>
                                <Typography
                                    variant='caption'
                                    sx={{
                                        color: '#6b7280',
                                        fontWeight: 600,
                                        textTransform: 'uppercase',
                                        fontSize: '11px'
                                    }}
                                >
                                    Contact
                                </Typography>
                                <Typography
                                    variant='body1'
                                    sx={{
                                        color: '#1f2937',
                                        fontWeight: 600,
                                        fontSize: '16px',
                                        fontFamily: 'monospace'
                                    }}
                                >
                                    {location.state.contact}
                                </Typography>
                            </Box>
                        </Box>

                        {/* Location */}
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px',
                                padding: '16px',
                                backgroundColor: '#f8fafc',
                                borderRadius: '12px',
                                border: '1px solid #e2e8f0'
                            }}
                        >
                            <LocationOn sx={{ color: '#4b5563', fontSize: '20px' }} />
                            <Box>
                                <Typography
                                    variant='caption'
                                    sx={{
                                        color: '#6b7280',
                                        fontWeight: 600,
                                        textTransform: 'uppercase',
                                        fontSize: '11px'
                                    }}
                                >
                                    Location
                                </Typography>
                                <Typography
                                    variant='body1'
                                    sx={{
                                        color: '#1f2937',
                                        fontWeight: 600,
                                        fontSize: '16px'
                                    }}
                                >
                                    {location.state.location}
                                </Typography>
                            </Box>
                        </Box>

                        {/* Date Added */}
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px',
                                padding: '16px',
                                backgroundColor: '#f8fafc',
                                borderRadius: '12px',
                                border: '1px solid #e2e8f0'
                            }}
                        >
                            <CalendarToday sx={{ color: '#4b5563', fontSize: '20px' }} />
                            <Box>
                                <Typography
                                    variant='caption'
                                    sx={{
                                        color: '#6b7280',
                                        fontWeight: 600,
                                        textTransform: 'uppercase',
                                        fontSize: '11px'
                                    }}
                                >
                                    Added on
                                </Typography>
                                <div style={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>
                                    <Typography
                                        variant='body1'
                                        sx={{
                                            color: '#1f2937',
                                            fontWeight: 600,
                                            fontSize: '16px'
                                        }}
                                    >
                                        {new Date(location.state.createdAt).toLocaleDateString(
                                            'en-US',
                                            {
                                                year: 'numeric',
                                                month: 'long',
                                                day: 'numeric'
                                            }
                                        )}
                                    </Typography>
                                    <Typography
                                        variant='caption'
                                        sx={{
                                            color: '#6b7280',
                                            fontSize: '16px',
                                            fontFamily: 'monospace'
                                            // marginTop: '2px'
                                        }}
                                    >
                                        at{' '}
                                        {new Date(location.state.createdAt).toLocaleTimeString(
                                            'en-US',
                                            {
                                                hour: '2-digit',
                                                minute: '2-digit',
                                                second: '2-digit',
                                                hour12: true
                                            }
                                        )}
                                    </Typography>
                                </div>
                            </Box>
                        </Box>
                    </Box>

                    {/* Farm Products Section */}
                    <Box sx={{ marginTop: '24px' }}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px',
                                marginBottom: '12px'
                            }}
                        >
                            <Agriculture sx={{ color: '#085d40', fontSize: '20px' }} />
                            <Typography
                                variant='subtitle1'
                                sx={{
                                    color: '#1f2937',
                                    fontWeight: 600
                                }}
                            >
                                Farm Products
                            </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                            {location.state.farmProducts.map((product, index) => (
                                <Chip
                                    key={index}
                                    label={product}
                                    sx={{
                                        backgroundColor: '#ecfdf5',
                                        color: '#064e3b',
                                        border: '1px solid #10b981',
                                        fontWeight: 500,
                                        '&:hover': {
                                            backgroundColor: '#d1fae5'
                                        }
                                    }}
                                />
                            ))}
                        </Box>
                    </Box>
                </CardContent>
            </Card>
            {/* Packages Section */}
            <Card
                sx={{
                    borderRadius: '16px',
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                    border: '1px solid #e5e7eb'
                }}
            >
                <Accordion
                    expanded={expanded === 'panel4'}
                    onChange={handleChange('panel4')}
                    sx={{
                        boxShadow: 'none',
                        border: 'none',
                        '&:before': {
                            display: 'none'
                        }
                    }}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: '#085d40' }} />}
                        aria-controls='panel4bh-content'
                        id='panel4bh-header'
                        sx={{
                            backgroundColor: '#f8fafc',
                            borderRadius: '16px 16px 0 0',
                            minHeight: '72px',
                            '&.Mui-expanded': {
                                minHeight: '72px',
                                borderRadius: '16px 16px 0 0'
                            }
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px',
                                width: '100%'
                            }}
                        >
                            <Inventory sx={{ color: '#085d40', fontSize: '24px' }} />
                            <Box>
                                <Typography
                                    variant='h6'
                                    sx={{
                                        color: '#1f2937',
                                        fontWeight: 600,
                                        margin: 0
                                    }}
                                >
                                    Packages ({location.state.packages?.length || 0})
                                </Typography>
                                <Typography variant='caption' sx={{ color: '#6b7280' }}>
                                    View and manage farmer packages
                                </Typography>
                            </Box>
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails sx={{ padding: '24px' }}>
                        {/* Print Button */}
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                marginBottom: '20px'
                            }}
                        >
                            <Button
                                variant='contained'
                                startIcon={<Print />}
                                onClick={() => PrintComponent()}
                                sx={{
                                    backgroundColor: '#085d40',
                                    borderRadius: '10px',
                                    padding: '10px 20px',
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    boxShadow: '0 2px 8px rgba(8, 93, 64, 0.25)',
                                    '&:hover': {
                                        backgroundColor: '#064532',
                                        boxShadow: '0 4px 12px rgba(8, 93, 64, 0.35)'
                                    }
                                }}
                            >
                                Print Packages
                            </Button>
                        </Box>
                        {/* Packages Table */}
                        <TableContainer
                            ref={compRef}
                            component={Paper}
                            sx={{
                                backgroundColor: '#ffffff',
                                borderRadius: '12px',
                                border: '1px solid #e2e8f0',
                                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
                                overflow: 'hidden'
                            }}
                        >
                            <Box
                                sx={{
                                    padding: '20px 24px',
                                    backgroundColor: '#f8fafc',
                                    borderBottom: '1px solid #e2e8f0'
                                }}
                            >
                                <Typography
                                    variant='h6'
                                    sx={{
                                        color: '#1f2937',
                                        fontWeight: 600,
                                        margin: 0
                                    }}
                                >
                                    Packages for {location.state.name}
                                </Typography>
                            </Box>

                            <Table
                                sx={{ minWidth: 650, tableLayout: 'fixed' }}
                                aria-label='packages table'
                            >
                                <TableHead
                                    sx={{
                                        backgroundColor: '#085d40',
                                        borderBottom: '2px solid #064532'
                                    }}
                                >
                                    <TableRow>
                                        <TableCell
                                            sx={{
                                                fontWeight: 600,
                                                fontSize: '12px',
                                                color: '#ffffff',
                                                textTransform: 'uppercase',
                                                padding: '16px',
                                                width: '200px'
                                            }}
                                        >
                                            Package
                                        </TableCell>
                                        <TableCell
                                            sx={{
                                                fontWeight: 600,
                                                fontSize: '12px',
                                                color: '#ffffff',
                                                textTransform: 'uppercase',
                                                padding: '16px',
                                                width: '120px'
                                            }}
                                        >
                                            Total
                                        </TableCell>
                                        <TableCell
                                            sx={{
                                                fontWeight: 600,
                                                fontSize: '12px',
                                                color: '#ffffff',
                                                textTransform: 'uppercase',
                                                padding: '16px',
                                                width: '100px'
                                            }}
                                        >
                                            Status
                                        </TableCell>
                                        <TableCell
                                            sx={{
                                                fontWeight: 600,
                                                fontSize: '12px',
                                                color: '#ffffff',
                                                textTransform: 'uppercase',
                                                padding: '16px',
                                                width: '120px'
                                            }}
                                        >
                                            Balance
                                        </TableCell>
                                        <TableCell
                                            sx={{
                                                fontWeight: 600,
                                                fontSize: '12px',
                                                color: '#ffffff',
                                                textTransform: 'uppercase',
                                                padding: '16px'
                                            }}
                                        >
                                            Products
                                        </TableCell>
                                    </TableRow>
                                </TableHead>

                                {Object.keys(location.state.packages).length > 0 ? (
                                    <TableBody>
                                        {location.state.packages.map((row, index) => (
                                            <TableRow
                                                key={index}
                                                sx={{
                                                    backgroundColor:
                                                        index % 2 === 0 ? '#ffffff' : '#f9fafb',
                                                    '&:hover': {
                                                        backgroundColor: '#f3f4f6'
                                                    }
                                                }}
                                            >
                                                <TableCell
                                                    component='th'
                                                    scope='row'
                                                    sx={{
                                                        padding: '16px',
                                                        fontSize: '14px',
                                                        fontWeight: 600,
                                                        color: '#1f2937',
                                                        cursor: 'pointer'
                                                    }}
                                                >
                                                    {row.name}
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        padding: '16px',
                                                        fontSize: '14px',
                                                        fontWeight: 500,
                                                        color: '#374151',
                                                        fontFamily: 'monospace'
                                                    }}
                                                >
                                                    {row.totalDue}
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        padding: '16px',
                                                        fontSize: '14px',
                                                        fontWeight: 500,
                                                        color: '#374151'
                                                    }}
                                                >
                                                    <Chip
                                                        label={row.status}
                                                        size='small'
                                                        sx={{
                                                            backgroundColor:
                                                                row.status === 'completed'
                                                                    ? '#ecfdf5'
                                                                    : '#fef3c7',
                                                            color:
                                                                row.status === 'completed'
                                                                    ? '#059669'
                                                                    : '#92400e',
                                                            border: `1px solid ${
                                                                row.status === 'completed'
                                                                    ? '#10b981'
                                                                    : '#f59e0b'
                                                            }`,
                                                            fontWeight: 600
                                                        }}
                                                    />
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        padding: '16px',
                                                        fontSize: '14px',
                                                        fontWeight: 500,
                                                        color: '#374151',
                                                        fontFamily: 'monospace'
                                                    }}
                                                >
                                                    {row.balance}
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        padding: '16px',
                                                        fontSize: '13px',
                                                        fontWeight: 500,
                                                        color: '#374151',
                                                        verticalAlign: 'top'
                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            flexWrap: 'wrap',
                                                            gap: '6px',
                                                            maxWidth: '250px'
                                                        }}
                                                    >
                                                        {row.products.map((prod, prodIndex) => (
                                                            <Chip
                                                                key={prodIndex}
                                                                label={prod}
                                                                size='small'
                                                                sx={{
                                                                    backgroundColor: '#f0fdf4',
                                                                    color: '#166534',
                                                                    border: '1px solid #bbf7d0',
                                                                    fontSize: '12px',
                                                                    fontWeight: 500,
                                                                    height: '24px',
                                                                    '&:hover': {
                                                                        backgroundColor: '#dcfce7',
                                                                        borderColor: '#86efac'
                                                                    }
                                                                }}
                                                            />
                                                        ))}
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                ) : (
                                    <TableBody>
                                        <TableRow>
                                            <TableCell
                                                colSpan={5}
                                                sx={{
                                                    textAlign: 'center',
                                                    padding: '40px',
                                                    color: '#6b7280',
                                                    fontSize: '16px'
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center',
                                                        gap: '12px'
                                                    }}
                                                >
                                                    <Inventory
                                                        sx={{ fontSize: '48px', color: '#d1d5db' }}
                                                    />
                                                    <Typography variant='body1'>
                                                        No packages found for this farmer
                                                    </Typography>
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                )}
                            </Table>
                        </TableContainer>
                    </AccordionDetails>
                </Accordion>
            </Card>
        </Box>
    );
}
